export function shouldShowPresentationLibraryViewSelect(options: { isGuest: boolean, canCreateResources: boolean, canUpgradeToUseSharedResources: boolean }) {
    const { isGuest, canCreateResources, canUpgradeToUseSharedResources } = options;
    return !isGuest && (canCreateResources || canUpgradeToUseSharedResources);
}
